import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useRef, useState } from "react";

const HomeBannerLt = () => {

   const banner = useRef();

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);

   useGSAP(() => {


      const t2 = gsap.timeline({
         repeat: -1,
         yoyo: true,
      });
      t2.fromTo('.hmBnrPicMv', {
         y: -5,
      }, {
         y: 5,
         yoyo: true
      },'bn1')
      t2.fromTo('.hmBnrPicsGd2', {         
         scale: 0.95
      }, {
         x: 2,
         scale: 1,
         yoyo: true
      },'bn1')
      t2.fromTo('.hmBnrPicsGd3', {
         x: 10,
         y: -5
      }, {
         x: 2,
         y: 0,
         scale: 1,
         yoyo: true
      },'bn1')
       t2.fromTo('.hmBnrPicsGd4', {
         y: 10,
         x: -5
      }, {
         y: 2,
         x: 0,
         yoyo: true
      },'bn1')

      

      // Auto animation tag and pictures
      const t1 = gsap.timeline({
         repeat: -1
      });

      let total_duration = 2;

      for (let i = 1; i < 7; i++) {
         t1.fromTo(`.hmbTgs${i}`,
            {
               "borderColor": "rgba(181, 181, 181, 0.60)",
               "background": "rgba(0, 0, 0, 0.85)",
               "boxShadow": "inset -1px 2px 4px rgba(194, 194, 194, 0.25), inset 4px -3px 8.70px rgba(162, 162, 162, 0.46)",
               //opacity: 0.5,
            },
            {
               "borderColor": "rgba(233,255,135,0.85)",
               "background": "rgb(33, 33, 33)",
               "boxShadow": "inset -1px 2px 4px rgba(239,255,15,0.25) , inset 4px -3px 8.70px rgba(150,150,150,0.46)",
               //opacity: 1,
               duration: 0.5,
               onStart: () => {
                  document.querySelector(`.hmbTgs${i}`).classList.add('active')
               }
            }, `tag${i}`);

         ScrollTrigger.matchMedia({
            "(max-width: 767px)": function () {
               t1.fromTo(`.hmBnrTx${i}`,
                  {
                     y: 50,
                     opacity: 0
                  },
                  {
                     y: 0,
                     opacity: 1,
                     duration: 0.75,
                  }, `tag${i}`);
               t1.fromTo(`.hmBnrPics${i}`,
                  {
                     opacity: 0
                  },
                  {
                     opacity: 1,
                     duration: 0.75,
                  }, `tag${i}`);
            }
         });


         t1.fromTo(`.hmbTgs${i}`, {},
            {
               onComplete: () => {
                  gsap.to(`.hmbTgs${i}`,
                     {
                        "borderColor": "rgba(181, 181, 181, 0.60)",
                        "background": "rgba(0, 0, 0, 0.85)",
                        "boxShadow": "inset -1px 2px 4px rgba(194, 194, 194, 0.25), inset 4px -3px 8.70px rgba(162, 162, 162, 0.46)",
                        //opacity: 0.5
                     });

                  ScrollTrigger.matchMedia({
                     "(max-width: 767px)": function () {
                        gsap.to(`.hmBnrTx${i}`,
                           {
                              opacity: 0,
                              y: 20,
                           })

                        gsap.to(`.hmBnrPics${i}`,
                           {
                              opacity: 0,
                           })
                     }
                  });

                  document.querySelector(`.hmbTgs${i}`).classList.remove('active')
               },
               duration: total_duration,
            }, `tag${i}`);
      }


      ScrollTrigger.matchMedia({
         "(min-width: 768px)": function () {
            let t2 = gsap.timeline({
               scrollTrigger: {
                  trigger: '.hmBnrTxPics',
                  start: "top 10%", // Start the animation when the top of the container reaches the center of the viewport
                  end: "1800% 0%", // End the animation when the bottom of the container reaches the top of the viewport
                  //scrub: true, // Smooth scrubbing
                  scrub: 1,
                  //markers: true,
                  //onEnter: () => t1.pause(),
                  pin: true,
                  // snap: 1,
                  //once: true
               }
            })

            for (let i = 1; i < 7; i++) {


               t2.fromTo(`.hmBnrTx${i}`,
                  {
                     y: 50,
                     opacity: 0
                  },
                  {
                     y: 0,
                     opacity: 1,
                     duration: 0.75,
                  }, `slide${i}`);

               if (i != 6) {
                  t2.fromTo(`.hmBnrTx${i}`,
                     {
                        y: 0,
                        opacity: 1
                     },
                     {
                        y: 50,
                        opacity: 0,
                        duration: 0.75,
                     }, `slide${i}_1`);
               }



               t2.fromTo(`.hmBnrPics${i}`,
                  {
                     opacity: 0
                  },
                  {
                     opacity: 1,
                     duration: 0.75,
                  }, `slide${i}`);
               if (i != 6) {
                  t2.fromTo(`.hmBnrPics${i}`,
                     {
                        opacity: 1
                     },
                     {
                        opacity: 0,
                        duration: 0.75,
                     }, `slide${i}_1`);
               }

            }
         }
      });

   }, []);

   useEffect(() => {

      setTimeout(() => {
         ScrollTrigger.refresh()
         banner.current?.classList.add('start');
      }, [1000])

   }, [])

   return (
      <section className="hmBnrLt" ref={banner}>
         <div className="hmBnrLtCon">
            <div className="container">

               <div className="hmBnrCnAr">

                  <div className="hmBnrLtVd">
                     <video src={require("../../../assets/banner/artistic-video.mp4")} muted loop autoPlay playsInline></video>
                  </div>

                  <div className="hmbTgs hmbTgs1">
                     <span className="hmbTgsIg">
                        <img src={require("../../../assets/banner/bill.svg").default} alt="bill" className="img-fluid" />
                     </span>
                     <span>Bill Routine</span>
                  </div>

                  <div className="hmbTgs hmbTgs2">
                     <span className="hmbTgsIg">
                        <img src={require("../../../assets/banner/roupay.svg").default} alt="roupay" className="img-fluid" />
                     </span>
                     <span>Rou Pay</span>
                  </div>

                  <div className="hmbTgs hmbTgs3">
                     <span className="hmbTgsIg">
                        <img src={require("../../../assets/banner/routine-swap.svg").default} alt="roupay" className="img-fluid" />
                     </span>
                     <span>Routine Swap</span>
                  </div>

                  <div className="hmbTgs hmbTgs4">
                     <span className="hmbTgsIg">
                        <img src={require("../../../assets/banner/doplan.svg").default} alt="doplan" className="img-fluid" />
                     </span>
                     <span>Doplantrip</span>
                  </div>

                  <div className="hmbTgs hmbTgs5">
                     <span className="hmbTgsIg">
                        <img src={require("../../../assets/banner/rtcbit.png")} width={22} height={'auto'} alt="rtcbit" className="img-fluid" />
                     </span>
                     <span>RTCbit</span>
                  </div>

                  <div className="hmbTgs hmbTgs6">
                     <span className="hmbTgsIg">
                        <img src={require("../../../assets/banner/routine.svg").default} alt="routine" className="img-fluid" />
                     </span>
                     <span>Doroutine</span>
                  </div>

                  <div className="hmBnrCnArIg">
                     <div className="hmBnrCnArIgGl"></div>
                     <img src={require("../../../assets/banner/center-coin.png")} alt="center-coin" className="img-fluid" />
                  </div>

               </div>


               <div className="hmBnrTxPics">
                  <div className="hmBnrTxAr">
                     <div className="hmBnrTx hmBnrTx1">
                        <h1>
                           <span>Crypto  Payment</span> <br /> Platform
                        </h1>
                     </div>

                     <div className="hmBnrTx hmBnrTx2">
                        <h1>
                           Crypto-Powered <br /> Prepaid <span>Debit Card</span>
                        </h1>
                     </div>

                     <div className="hmBnrTx hmBnrTx3">
                        <h1>
                           Web3 based <br /> decentralized <span>exchange</span>
                        </h1>
                     </div>

                     <div className="hmBnrTx hmBnrTx4">
                        <h1>
                           <span>WEB3 travel</span> <br /> Platform
                        </h1>
                     </div>

                     <div className="hmBnrTx hmBnrTx5">
                        <h1>
                           The  Ultimate <br /> <span>trading</span> experience
                        </h1>
                     </div>

                     <div className="hmBnrTx hmBnrTx6">
                        <h1>
                           <span>Ecommerce</span> <br /> Platform
                        </h1>
                     </div>
                  </div>

                  <div className="hmBnrPics">
                     <div className="hmBnrPics1">
                        <img src={require("../../../assets/banner/picture-1.png")} alt="picture-1" className="img-fluid" />
                     </div>
                     <div className="hmBnrPics2">
                        <img src={require("../../../assets/banner/picture-2.png")} alt="picture-2" className="img-fluid" />
                     </div>
                     <div className="hmBnrPics3">
                        <img src={require("../../../assets/banner/picture-3.png")} alt="picture-2" className="img-fluid" />
                     </div>
                     <div className="hmBnrPics4">
                        <img src={require("../../../assets/banner/picture-4.png")} alt="picture-2" className="img-fluid" />
                     </div>
                     <div className="hmBnrPics5">
                        <img src={require("../../../assets/banner/picture-5.png")} alt="picture-2" className="img-fluid" />
                     </div>
                     <div className="hmBnrPics6 text-center">
                        <div className="hmBnrPicsGd">
                           <img src={require("../../../assets/banner/picture-6.png")} alt="picture-2" className="img-fluid hmBnrPicsGd1" />
                           <img src={require("../../../assets/banner/picture-6-1.png")} alt="picture-2" className="img-fluid hmBnrPicsGd2" />
                           <img src={require("../../../assets/banner/picture-6-2.png")} alt="picture-2" className="img-fluid hmBnrPicsGd3" />
                           <img src={require("../../../assets/banner/picture-6-3.png")} alt="picture-2" className="img-fluid hmBnrPicsGd4" />

                           <div className="hmBnrPicMv">
                              <img src={require("../../../assets/pics/roupay-coin.png")} alt="roupay-coin" />
                           </div>
                        </div>

                     </div>
                  </div>
               </div>

            </div>
         </div>

      </section>
   )
}
export default HomeBannerLt;